import { Injectable } from '@angular/core';

import { Grade } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class GradeService extends TmsWebBaseEditService<Grade, Grade> {
  constructor() {
    super('Grade', $localize`Grade`);
  }
}
